import React, { useRef, useState } from 'react';
import { compose } from 'redux';

import withCalculateSticky from './withCalculateSticky';
// eslint-disable-next-line import/no-named-as-default,import/no-named-as-default-member
import enhancerZoomHandlersHOC from './EnhancerZoomHandlersHOC';

export const setupStickyProps = (Component) => {
  function SetupStickyPropsHOC(props) {
    const refOnTopSection = useRef();
    const refOnToolbar = useRef();
    const [stickyInfo, updateSticky] = useState({
      isSticky: false,
      height: 0,
      topSectionHeight: 0,
    });
    const [doesZoomHovered, updateZoomHovered] = useState(false);
    return (
      <Component
        {...props}
        refOnTopSection={refOnTopSection}
        refOnToolbar={refOnToolbar}
        stickyInfo={stickyInfo}
        updateSticky={updateSticky}
        doesZoomHovered={doesZoomHovered}
        updateZoomHovered={updateZoomHovered}
      />
    );
  }

  return SetupStickyPropsHOC;
};

export default compose(setupStickyProps, enhancerZoomHandlersHOC, withCalculateSticky);
